const a = {
  id: "TristatePick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#665fac"
  }
};
export {
  a as default
};
